<template>
  <!-- Use the new navigation component -->
  <InpatientNav />

  <!-- Page Layout -->
  <BaseLayout
    :mainUrl="mainUrl"
    :tableSearchUrl="searchUrl"
    :searchPlaceholder="placeHolderText"
    @child-data-state-mount="handle_external_mount"
  >
    <!-- table heading -->
    <template v-slot:table-heading>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        #s/n
      </th>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Patient Name
      </th>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
      >
        OPD/IPD
      </th>
      <th
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Visit Start time
      </th>
      <th class="text-secondary opacity-7"></th>
    </template>

    <!-- table content -->
    <template v-slot:table-contents-place>
      <tr v-for="user in users" :key="user.id">
        <td>#{{ user.id }}</td>
        <td>
          <div class="d-flex px-2 py-1">
            <div class="d-flex flex-column justify-content-center">
              <h6 class="mb-0 text-sm">{{ user.name }}</h6>
              <p class="text-xs text-secondary mb-0">
                {{ user.email == null ? "--" : user.email }}
              </p>
            </div>
          </div>
        </td>
        <td>
          <p class="text-xs font-weight-bold mb-0">
            OPD/{{ user.opd == null ? "--" : user.opd }}
          </p>
          <p class="text-xs text-secondary mb-0">
            IPD/{{ user.ipd == null ? "--" : user.ipd }}
          </p>
        </td>
        <td class="align-middle text-center text-sm">
          <soft-badge color="success" variant="gradient" size="sm">
            {{ formatDateTime_int(user.visit_datetime) }}
          </soft-badge>
        </td>
        <td class="align-middle">
          <a
            :href="'/inpatient/inpatient_timeline/' + user.id"
            class="btn-service"
          >
            Service
          </a>
        </td>
      </tr>
    </template>
  </BaseLayout>
</template>

<script>
import BaseLayout from "../Patients/components/table_page_layout.vue";
import formatDateTime from "../../timezone/utc_local_time.js";
import InpatientNav from "./inpatient_nav.vue"; // 👈 import here 

export default {
  name: "patientsindex",
  components: {
    BaseLayout,
    InpatientNav, // 👈 register component
  },
  data() {
    return {
      users: [],
      allData: {},
      apiLoading: false,
      tableLoading: true,
      placeHolderText: "Search name,phone,email,opd/ipd",
      searchUrl: "searchCompanyUsers",
      mainUrl: "get_all_inpatient_queue",
    };
  },
  methods: {
    handle_external_mount(payload) {
      this.users = payload;
    },
    formatDateTime_int(payload) {
      return formatDateTime(payload);
    },
  },
};
</script>

<style scoped>
.btn-service {
  border: 1px solid #16a34a;
  padding: 4px 10px;
  color: #16a34a;
  font-weight: 600;
  border-radius: 6px;
  font-size: 0.8rem;
  transition: all 0.2s ease;
}
.btn-service:hover {
  background: #16a34a;
  color: #fff;
}
</style>
